<template>
	<div>
		<ExpensesTabs
			:key="expenses_tabs"
			:tab="'Claims'"
			@tab="onTabChange($event)"
		/>
		<ProgressGetDataLinear v-if="loading" class="px-5"/>
		<div class="new-claim" v-if="!loading">
			<ClaimDetailTitle
				class="head-title my-4 d-print-none" 
				:title="`Create new claim`" 
				:text="'Back'"
				@back="leave_dialog = true"
			/>
			<v-alert class="new-claim-error" type="error" v-if="error_msg.length !== 0">
				{{ error_msg }}
			</v-alert>
			<ClaimContent 
				:color="color" 
				:currencies="currencies"
				:items="receipts_local"
				:update_receipts="update_receipts"
				@add-receipts="receipt_list_visible = true"
				@row-click="onRowClick($event)"
				@delete="onDelReceipts($event)"
				@back="onBack()"
			/>
			<AddReceiptsDialog 
				v-if="receipt_list_visible" 
				:visible="receipt_list_visible" 
				:color="color" 
				:currencies="currencies"
				:exist="receipts_local.map(rec => {return rec.id})"
				@error="onError($event)"
				@visible="receipt_list_visible = false"
				@add-receipts="onReceiptAdd($event)"
			/>
			<EditReceiptDialog
				v-if="receipt_edit_visible"
				:visible="receipt_edit_visible" 
				:color="color" 
				:currencies="currencies"
				:receipt="receipt"
				:errorMessage="errorMessage"
				@close="onReceiptClose()"
				@save="onReceiptSave($event)"
			/>
			<LeaveReceiptsDialog
				v-if="leave_dialog"
				:visible="leave_dialog"
				:type="'warning'"
				:title_text="`Unsaved claim`"
				:content_text="`This claim will not be saved if you leave the page.`"
				:cancel_button="`Leave page`"
				:confirm_button="`Stay on page`"
				@cancel="onBack()"
				@ok="onStayOnPage()"
			/>
		</div>
	</div>
</template>

<script>
import ClaimDetailTitle from "@/views/expenses/commond/claim_detail_title.vue";
import ClaimContent from "@/views/expenses/claims/claim_content";
import AddReceiptsDialog from '@/views/expenses/claims/add_receipts_dialog';
import EditReceiptDialog from '@/views/expenses/commond/edit_receipt_dialog';
import LeaveReceiptsDialog from "@/components/expenses/leave_receipts_dialog";
import ExpensesTabs from "@/views/expenses/commond/expenses_tabs";
import ProgressGetDataLinear from "@/components/progress/progress_getdata_linear.vue";

export default {
	name: 'NewClaims',
	components: {
		ClaimDetailTitle,
		ClaimContent,
		AddReceiptsDialog,
		EditReceiptDialog,
		LeaveReceiptsDialog,
		ExpensesTabs,
		ProgressGetDataLinear
	},
	data() {
		return {
			error_msg: '',
			errorMessage: '',
			loading: false,
			color: this.$attrs.color ? this.$attrs.color : '#FFB946',
			currencies: [],
			receipts_local: [],
			receipt: null,
			update_receipts: [],

			receipt_list_visible: false,
			receipt_edit_visible: false,
			leave_dialog: false,
			tab_tmp: '',
			expenses_tabs: 0
		}
	},
	async created() {
		this.listCountries();
		this.update_breadcrumb();

		if (this.$route.query.ids) {
			this.loading = true;
			this.receipts_local = [];
			const ids = this.$route.query.ids.split('&');

			for (let index = 0; index < ids.length; index++) {
				const element = ids[index];
				await this._getReceipt(element);
			}
			if (this.receipts_local.length === ids.length) {
				this.loading = false;
			}
		} else {
			this.receipts_local = [];
		}
	},
	methods: {
		listCountries() {
			const url = `/api/config/country`;

			return axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						if (data.length !== 0) {
							const currencies_by_id = new Map();

							data.forEach(country => {
								if (!country.currency) return;

								const { currency, ...country_details } = country;
								if (!currencies_by_id.has(currency.id)) {
									currencies_by_id.set(currency.id, Object.assign({}, currency, {
										countries: []
									}));
								}

								currencies_by_id.get(currency.id).countries.push(country_details);
							});

							this.currencies = Array.from(currencies_by_id.values());
						}
					} else {
						this.error_msg = reason;
						this.loading = false;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
					this.loading = false;
				});
		},
		onBack() {
			if (this.tab_tmp.length !== 0) {
				this.$router.push({ name: this.tab_tmp });
			} else {
				this.$router.push({ name: 'Claims' });
			}
		},
		onStayOnPage() {
			this.leave_dialog = false;
			this.expenses_tabs += 1;
		},
		onTabChange(current_tab) {
			this.tab_tmp = current_tab;
			this.leave_dialog = true;
		},
		onRowClick(receipt_obj) {
			if (receipt_obj.code) {
				const obj = receipt_obj.code;
				if (obj.display_name.includes(obj.code)) {
					obj['display_name'] = `${obj.display_name}`;
				} else {
					obj['display_name'] = `${obj.code} - ${obj.display_name}`;
				}	

				receipt_obj['job'] = obj;
			} else {
				receipt_obj['job'] = null;
			}

			this.receipt = receipt_obj;
			
			this.receipt_edit_visible = true;
		},
		onError(msg) {
			if (msg.length !== 0) {
				this.receipt_list_visible = false;
				this.error_msg = msg;
			}
		},
		onReceiptAdd(receipts) {
			this.receipt_list_visible = false;
			if (this.receipts_local.length !== 0) {
				const receipts_ids = this.receipts_local.map(rec => {
					return rec.id;
				});
				receipts.forEach(rec => {
					if (!receipts_ids.includes(rec.id)) {
						this.receipts_local.push(rec);
					}
				});
			} else {
				this.receipts_local = receipts;
			}
		},
		onReceiptSave(updateObj) {
			this._updateReceipt(updateObj);
		},
		onDelReceipts(del_ids) {
			this.receipts_local = this.receipts_local.filter(res => {
				return !del_ids.includes(res.id);
			});
		},
		onReceiptClose() {
			this.receipt_edit_visible = false;
		},
		update_breadcrumb() {
			// add this page to our breadcrumbs
			this.$store.commit("push_breadcrumb", {
				exact: true,
				text: 'New Claim',
				to: '/expenses/claims/new_claim'
			});
		},
		_updateReceipt(item) {
			if (item.job && item.kind && item.kind.overhead_mode === 1 && !item.job.is_overhead) {
				this.errorMessage = "You can't use an overhead kind on a client job";
				return ;

			} else if (item.job && item.kind && item.kind.overhead_mode === 0 && item.kind.show_over === 0 && item.job.is_overhead) {
				this.errorMessage = "You can't use a client kind on an overhead job";
				return ;
			}; 

			this.receipts_local.forEach(receipt => {
				if (receipt.id === item.id) {
					receipt.currency = item.currency;
					receipt.date = item.date;
					receipt.desc = item.description;
					receipt.has_tax = item.has_tax;
					receipt.job = item.job;
					receipt.kind = item.kind;
					receipt.phase = item.phase;
					receipt.value = item.value;
					receipt.tax_amount = item.tax_amount;
					receipt.tax_perc = item.tax_perc;
					receipt.tax_mode = item.tax_mode;
					receipt.markup_perc = item.markup_perc;
					receipt.markup_value = item.markup_value;
					receipt.image = item.image;
					receipt.image_type = item.image_type;
				}
			});

			if (!this.update_receipts.includes(item.id)) {
				this.update_receipts.push(item.id);
			}

			if (this.receipt_edit_visible) {
				this.receipt_edit_visible = false;
			}
		},
		async _getReceipt(id) {
			const url = `/api/expenses/receipts/${id}`;
			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						this.receipts_local.push(data);
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		}
	}
}
</script>
<style lang="scss" scoped>
.new-claim {
  display: flex;
  flex-flow: column nowrap;
	padding: 0 24px 24px 24px;
}
.new-claim-title {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 68px;
  .btn {
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 36px;
    color: #00AAFD;
    &:hover {
      cursor: pointer;
    }
    span {
      text-decoration: underline;
    }
  }
	.text {
		font-family: Roboto;
		font-style: normal;
		font-weight: bold;
		font-size: 16px;
		line-height: 24px;
		color: #192A3E;
	}
}
.new-claim-error {
  width: 98%;
}
.hidden {
	display: none;
}
</style>